import React from "react";
import { Text } from "@chakra-ui/react";
import { TextProps } from "@chakra-ui/layout/dist/types/text";

interface IProps extends TextProps {}

const ChakraText = ({ children, ...props }: IProps) => {
  return (
    <Text fontSize="md" letterSpacing="normal" {...props}>
      {children}
    </Text>
  );
};

export { ChakraText };
